'use strict';

var util = require('./util'),
    cart = require('./pages/cart'),
    page = require('./page'),
    layout = require('./layout'),
    bonusProductsView = require('./../../../app_storefront_core/cartridge/js/bonus-products-view');

var emitter = window.eventMgr.getEmitter('miniCart');

var $cache = {},
    selectors = {
        miniCart: '.js-minicart',
        qtyBtn: '.js-qty',
        removeBtn: '.js-item-remove',
        itemQtyField: '.js-item-quantity-field',
        minicartOverlay: '.js-overlay-nav',
        miniCartContent: '.mini-cart-content',
        miniCartToggle: '.mini-cart-toggle',
        miniCartTotal: '.mini-cart-total',
        minicartRedirect: '.js-minicart-redirect'
    },
    cssConstants = {
        hideClass: 'is--hidden',
        showOverlayClass: 'is--mini-cart-show',
        isExpandedClass: 'is--expanded'
    };

function miniCartToggle(showMinicart) {
    if (showMinicart && $cache.$el.find(selectors.minicartRedirect).length) {
        page.redirect(Urls.showCart);
        return;
    }

    $cache.$el.find(selectors.miniCartContent).toggleClass(cssConstants.hideClass, !showMinicart);
    $cache.html.toggleClass(cssConstants.showOverlayClass, showMinicart);
    $cache.minicartOverlay.toggleClass(cssConstants.isExpandedClass, showMinicart);
    $cache.body.toggleClass('mini-cart-show', showMinicart);
    if (!showMinicart) {
        $cache.document.trigger('minicart.close', false);
    }
    $cache.document.trigger('minicart.show');
    emitter.emit('show');
    $cache.minicartOverlay.removeClass('is--mobile-expanded');
}

function initializeCache() {
    $cache.document = $(document);
    $cache.html = $(document.documentElement);
    $cache.body = $(document.body);
    $cache.$el = $(selectors.miniCart);
    $cache.minicartOverlay = $cache.document.find(selectors.minicartOverlay);
}

function initializeEvents() {
    $cache.$el
        .on('click', selectors.qtyBtn, function (e) {
            e.stopPropagation();
            e.preventDefault();
            cart.updateQty(this);
            if (pageContext.ns === 'cart') {
                $cache.minicartOverlay.removeClass(cssConstants.isExpandedClass);
            }
        })
        .on('click', selectors.removeBtn, function (e) {
            e.preventDefault();
            var $lineItem = $(this).closest('.js-line-item-row');
            var url = util.appendParamToURL(Urls.removeProductFromMinicart, 'uuid', $lineItem.data('uuid'));

            $cache.document.trigger('product.removeFromCart', [$lineItem, $lineItem.find('input.js-item-quantity-field').val()]);
            cart.updateCart(url);
        })
        .on('click', selectors.miniCartTotal, () => {
            miniCartToggle(true);
            $cache.document.trigger('menu.close');
            emitter.emit('toggled');
        })
        .on('change', selectors.itemQtyField, function () {
            cart.updateQtyOnInput(this, (parseInt($(this).val(), 10) === 0));
            $cache.html.toggleClass(cssConstants.showOverlayClass, false);
        });

    $cache.document
        .on('click', selectors.miniCartToggle + ', ' + selectors.minicartOverlay, () => miniCartToggle(false))
        .on('minicart.close', () => {
            $cache.$el.find(selectors.miniCartContent).toggleClass(cssConstants.hideClass, true);
            $cache.body.removeClass('mini-cart-show');
            $cache.html.toggleClass(cssConstants.showOverlayClass, false);
        });

    if (layout.isMobile() || layout.isTablet()) {
        $(selectors.itemQtyField).prop('disabled', true);
    }
}

var minicart = {
    init: function () {
        initializeCache();
        initializeEvents();
    },

    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html) {
        this.update(html);
        util.scrollBrowser(0);
        miniCartToggle(true);
        bonusProductsView.loadBonusOption();
    },

    update: function (html) {
        var $update = $(html).filter((index, node) => {
            return node.nodeName === 'DIV';
        }).html();
        $cache.$el.html($update);
    },

    loadBonusProducts: bonusProductsView.loadBonusOption,

    miniCartToggle: miniCartToggle
};

module.exports = minicart;
